import { useWebThemeContext } from '~/components/Layout/Context/useWebThemeContext';

import EmailIconWrapper from '../Base/EmailIconWrapper';
import EmailInput from '../Base/EmailInput';
import InputWrapper from '../Base/InputWrapper';
import SubmitButton from '../Base/SubmitButton';
import type { TemplateProps } from '../types';

const rightRoundedClass = (radius: any) => {
  switch (radius) {
    case 'none':
      return 'rounded-none sm:rounded-r-none';
    case 'sm':
      return 'rounded-none sm:rounded-sm-r';
    case 'md':
      return 'rounded-none sm:rounded-md-r';
    case 'lg':
      return 'rounded-none sm:rounded-lg-r';
    case 'xl':
      return 'rounded-none sm:rounded-xl-r';
    case '2xl':
      return 'rounded-none sm:rounded-2xl-r';
    case '3xl':
      return 'rounded-none sm:rounded-3xl-r';
    default:
      return 'rounded-none';
  }
};

const Template2 = ({ signupStyles, isSubmitting, autoFocus, setEmail, onEmailChange }: TemplateProps) => {
  const { webTheme } = useWebThemeContext();
  const {
    fontFamily,
    buttonFontFamily,
    buttonBgColor,
    buttonTextColor,
    placeholderBgColor,
    placeholderTextColor,
    buttonText,
    placeholderText,
    borderEnabled,
    borderColor,
    emailIconEnabled,
  } = signupStyles;

  const radiusClass = rightRoundedClass(webTheme.radius);

  return (
    <InputWrapper
      style={{
        backgroundColor: placeholderBgColor,
        border: borderEnabled ? `2px solid ${borderColor}` : 'none',
      }}
      className="overflow-hidden"
    >
      <EmailIconWrapper
        color={buttonBgColor || ''}
        style={{
          backgroundColor: placeholderBgColor,
        }}
        iconEnabled={emailIconEnabled}
      >
        <EmailInput
          fontFamily={fontFamily}
          autoFocus={autoFocus}
          setEmail={setEmail}
          onEmailChange={onEmailChange}
          placeholderText={placeholderText}
          textColor={placeholderTextColor}
        />
      </EmailIconWrapper>
      <SubmitButton
        isSubmitting={isSubmitting}
        fontFamily={buttonFontFamily}
        ctaText={buttonText}
        backgroundColor={buttonBgColor}
        textColor={buttonTextColor}
        className={radiusClass}
        shouldAdjustRadius
      />
    </InputWrapper>
  );
};

export default Template2;
